import { render } from "./IconWarning.vue?vue&type=template&id=4aa0a48d"
import script from "./IconWarning.vue?vue&type=script&lang=js"
export * from "./IconWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__